import { Box } from '@mui/system';
import { TextField } from '@mui/material';
import { WidgetOption } from './WidgetSelector';
import { NumericInput } from '../NumericInputField';

type ClassifierRanking = Models.SetsPlayground.ClassifierSetRanking;

interface Props {
    value: ClassifierRanking;
    onChange: (next: ClassifierRanking) => void;
}

const ClassifierRankingWidgetComponent = ({ value, onChange }: Props): JSX.Element => {
    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        onChange({
            ...value,
            classifierReranking: { ...value.classifierReranking, classifierName: e.target.value },
        });
    };

    const handleWeightChange = (newValue: number | undefined): void => {
        onChange({
            ...value,
            classifierReranking: { ...value.classifierReranking, weight: newValue ?? 1 },
        });
    };

    return (
        <Box display="grid" gap={2} gridTemplateColumns={{ xs: '1fr', sm: '2fr 1fr' }}>
            <TextField
                fullWidth
                required
                label="Classifier Name"
                placeholder="e.g. MM_INTERESTING_SECTIONED"
                size="small"
                value={value.classifierReranking.classifierName}
                onChange={handleNameChange}
            />
            <NumericInput
                allowDecimals
                label="Weight (0–1)"
                max={1}
                min={0}
                value={value.classifierReranking.weight}
                onChange={handleWeightChange}
            />
        </Box>
    );
};

export const ClassifierRankingWidget: WidgetOption<ClassifierRanking> = {
    label: 'Classifier Reranking',
    value: 'classifier',
    helperText: 'Provide a classifier name and weight for reranking.',
    component: ClassifierRankingWidgetComponent,
    getDefaultValue: () => ({
        type: 'classifier',
        classifierReranking: { classifierName: '', weight: 1 },
    }),
};
